module.exports = __webpack_public_path__ + "img/presencial-tel-01.8ed7a06d.svg";